module.exports = __webpack_public_path__ + "static/media/logo.51d952c3.svg";